import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ExtensionCapabilityQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type ExtensionCapabilityQuery = { __typename?: 'Query', userCapabilities?: Array<Types.Capability | null> | null };


export const ExtensionCapabilityDocument = gql`
    query ExtensionCapability($userId: Int!) {
  userCapabilities(userId: $userId)
}
    `;

/**
 * __useExtensionCapabilityQuery__
 *
 * To run a query within a React component, call `useExtensionCapabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtensionCapabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtensionCapabilityQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useExtensionCapabilityQuery(baseOptions: Apollo.QueryHookOptions<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables> & ({ variables: ExtensionCapabilityQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>(ExtensionCapabilityDocument, options);
      }
export function useExtensionCapabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>(ExtensionCapabilityDocument, options);
        }
export function useExtensionCapabilitySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>(ExtensionCapabilityDocument, options);
        }
export type ExtensionCapabilityQueryHookResult = ReturnType<typeof useExtensionCapabilityQuery>;
export type ExtensionCapabilityLazyQueryHookResult = ReturnType<typeof useExtensionCapabilityLazyQuery>;
export type ExtensionCapabilitySuspenseQueryHookResult = ReturnType<typeof useExtensionCapabilitySuspenseQuery>;
export type ExtensionCapabilityQueryResult = Apollo.QueryResult<ExtensionCapabilityQuery, ExtensionCapabilityQueryVariables>;